import { useQuery } from "react-query";
import { getAvailableUserAssignmentGroups } from "../../../admin/user-roles/lib/userData";

export const useAvailableUserAssignments = () => {
    return useQuery({
        queryKey: ["userAvailableAssignments"],
        queryFn: async () => {
            const userAssignments = await getAvailableUserAssignmentGroups();

            return userAssignments.items;
        },
        initialData: [],
    });
};
